import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Clock, Award, TrendingUp, FileText } from 'lucide-react';
import { Card } from '../../ui/card';
import { itemVariants } from '../../../utils/animations';
import { formatCurrency } from './utils/payrollUtils';

interface PayrollStatsProps {
  totalBaseSalary: number;
  totalOvertime: number;
  totalKPIBonus: number;
  totalPayroll: number;
  totalEmployees: number;
}

export default function PayrollStats({
  totalBaseSalary,
  totalOvertime,
  totalKPIBonus,
  totalPayroll,
  totalEmployees,
}: PayrollStatsProps) {
  return (
    <motion.div variants={itemVariants} className="grid grid-cols-2 lg:grid-cols-5 gap-4">
      <Card className="border-l-4 border-l-blue-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Gaji Pokok</p>
              <p className="text-2xl font-bold">{formatCurrency(totalBaseSalary)}</p>
            </div>
            <DollarSign className="w-8 h-8 text-blue-500" />
          </div>
        </div>
      </Card>

      <Card className="border-l-4 border-l-orange-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Total Lembur</p>
              <p className="text-2xl font-bold">{formatCurrency(totalOvertime)}</p>
            </div>
            <Clock className="w-8 h-8 text-orange-500" />
          </div>
        </div>
      </Card>

      <Card className="border-l-4 border-l-purple-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Bonus KPI</p>
              <p className="text-2xl font-bold">{formatCurrency(totalKPIBonus)}</p>
            </div>
            <Award className="w-8 h-8 text-purple-500" />
          </div>
        </div>
      </Card>

      <Card className="border-l-4 border-l-emerald-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Total Dibayar</p>
              <p className="text-2xl font-bold">{formatCurrency(totalPayroll)}</p>
            </div>
            <TrendingUp className="w-8 h-8 text-emerald-500" />
          </div>
        </div>
      </Card>

      <Card className="border-l-4 border-l-gray-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Pegawai</p>
              <p className="text-2xl font-bold">{totalEmployees}</p>
              <p className="text-xs text-gray-500">
                Avg: {formatCurrency(totalEmployees > 0 ? totalPayroll / totalEmployees : 0)}
              </p>
            </div>
            <FileText className="w-8 h-8 text-gray-500" />
          </div>
        </div>
      </Card>
    </motion.div>
  );
}
